import * as React from "react";

import {
  NavItemProps as BaseNavITemProps,
  StyledNavItem,
} from "baseui/side-navigation";

import { HintDot } from "baseui/badge";
import { HorizontalSpacer } from "kanopi-components/SpaceWrapper/HorizontalSpacer";
import { Icon } from "baseui/icon";
import { Item } from "baseui/menu";
import { ParagraphSmall } from "baseui/typography";
import { SidePadder } from "kanopi-components/SpaceWrapper/SidePadder";
import { useStyletron } from "kanopi-components/theme/useStyletron";

export type CustomItem = Item & {
  icon: React.ReactNode;
  hintOnCollapse?: boolean;
  endEnhancer?: React.ReactNode;
  onClick?: (e: Event | KeyboardEvent, item: Item) => void;
};
export type NavItemProps = {
  collapsed?: boolean;
  item: CustomItem;
} & BaseNavITemProps;

export const LeftNavItem: React.FC<NavItemProps> = (props) => {
  const { collapsed = false, item, ...navItemProps } = props;
  const [, theme] = useStyletron();
  const {
    title,
    icon,
    hintOnCollapse = false,
    hintColor = theme.colors.negative,
    endEnhancer,
  } = item;
  return (
    <StyledNavItem
      {...navItemProps}
      style={{
        paddingLeft: 0,
        paddingRight: 0,
      }}
      data-testid={item.itemId}
    >
      <SidePadder padding={collapsed ? "none" : "section"}>
        {collapsed && (
          <HorizontalSpacer justifyContent="center">
            {hintOnCollapse && (
              <HintDot
                overrides={{
                  Badge: {
                    style: {
                      width: theme.sizing.scale100,
                      height: theme.sizing.scale100,
                      borderColor: hintColor,
                      backgroundColor: hintColor,
                    },
                  },
                  Root: {
                    style: {
                      height: theme.sizing.scale700,
                    },
                  },
                }}
              >
                {icon && <Icon size={theme.sizing.scale700}>{icon}</Icon>}
              </HintDot>
            )}
            {!hintOnCollapse && icon && (
              <Icon size={theme.sizing.scale700}>{icon}</Icon>
            )}
          </HorizontalSpacer>
        )}

        {!collapsed && (
          <HorizontalSpacer justifyContent="space-between">
            <HorizontalSpacer justifyContent="left">
              {icon && <Icon size={theme.sizing.scale700}>{icon}</Icon>}
              <ParagraphSmall
                marginTop={0}
                marginBottom={0}
                paddingTop={0}
                paddingBottom={0}
                color="inherit"
              >
                {title}
              </ParagraphSmall>
            </HorizontalSpacer>
            {endEnhancer}
          </HorizontalSpacer>
        )}
      </SidePadder>
    </StyledNavItem>
  );
};
